import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const HexagonCountWrapper = Styled.div`
	z-index:1;
`;

const NumberWrapper = Styled.div`
	position:absolute;
	line-height:26px;
	height:26px;
	width:22px;
	text-align:center;
	color:#535353;
	font-weight: 500;
`;

const SVGWrapper = Styled.div`
	height:26px;
	text-align:center;

`;

export const HexagonCount = ({number, remainingNames}) => {
	return (
		<HexagonCountWrapper title={remainingNames}>
			<NumberWrapper>+{number}</NumberWrapper>
			<SVGWrapper>
				<svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M0.5 6.78532L11 0.58077L21.5 6.78531V19.2147L11 25.4192L0.5 19.2147V6.78532Z"
						fill="white"
						stroke="#DBDBDB"
					/>
				</svg>
			</SVGWrapper>
		</HexagonCountWrapper>
	);
};

HexagonCount.propTypes = {
	number: PropTypes.number,
	remainingNames: PropTypes.string,
};
